import { pipelineChangeDetectionLegend, pipelineGreenLegend } from '../config/legends'
import { getBrand } from '../selectors/brandSelector'

const ENERGIR = getBrand() === 'Energir'

const service = {
  name: 'Energir',
  label: ENERGIR ? 'Energir' : 'Monitor',
  permissionId: 'energir',
  iconComponent: 'Pipeline',
  showCoordinates: true,
  hideDatetimeSlider: true,
  disableMainDate: true,
  showDissolveClock: true,
  dataTable: 'energir-hazard',
  data: [
  ],
  layers: [
    // {
    //   name: 'EnergirMeasures',
    //   label: 'Measures',
    //   opacity: 'cirlce-opacity',
    //   hidden: true
    // },
    {
      name: 'EnergirChange',
      label: 'Change',
      transparencyLabel: 'Change detection',
      disableToggle: true,
      disableTitle: true,
      hidden: true,
      hideLabel: true,
      open: true,
      opacity: 'fill-opacity',
      datetimeId: 'PipelineChangeDetection',
      secondary: false,
      datetimeId: 'PipelineGreen',
      legend: {
        type: 'categorical',
        data: pipelineChangeDetectionLegend
      },
      filter: {
        min: 0,
        max: 10,
        value: 0,
        label: '  change',
        title: 'Change threshold',
        transformLabel: '% change',
        transform: value => `≥ ${value * 10}`,
        transformIn: value => value,
        transformOut: value => value
      }
    },
    // {
    //   name: 'PipelineMask',
    //   label: 'Pipeline outline',
    //   opacity: 'raster-opacity',
    //   hidden: true
    // },
    {
      name: 'Energir',
      label: 'Weekly mosaic',
      opacity: 'raster-opacity',
      datetimeId: 'Energir',
      secondary: false,
      open: true,
      transparencyLabel: 'Weekly imagery',
      transparencyMarks: {
        0: { label: 'Previous', value: 0 },
        100: { label: 'Current', value: 100 }
      },
      transparencyOptions: {
        label: 'hi'
      },
      hideLabel: true,
      disableToggle: true
    },
    // {
    //   name: 'Sentinel2PipelineChangeDetectionBase',
    //   // name: 'Sentinel2',
    //   label: 'Sentinel 2 (10 m)',
    //   opacity: 'raster-opacity',
    //   datetimeId: 'PipelineChangeDetectionBase',
    //   secondary: false,
    //   hidden: true
    // },
    // {
    //   name: 'PipelineGreen',
    //   label: 'Green band',
    //   opacity: 'raster-opacity',
    //   datetimeId: 'PipelineGreen',
    //   legend: {
    //     type: 'categorical',
    //     data: pipelineGreenLegend
    //   }
    // },
  ],
  locations: [
    {
      name: ENERGIR ? 'Pipeline' : 'Pipeline',
      latitude: 45.3527,
      longitude: -72.6935,
      zoom: [10]
    },
    // {
    //   name: 'Pipeline',
    //   latitude: 48.513054670113938,
    //   longitude: -71.656869225589588,
    //   zoom: [12]
    // }
  ]
}

export default service



// WEBPACK FOOTER //
// ./src/services/Energir.js